import { createContext } from 'react';
import bidContextInitialState from '../../BidModal/bidContextInitialState';

// create useContext
const BidBoxContext = createContext({
  bidContext: bidContextInitialState,
  setBidContext: () => null,
  bidModalOpen: false,
  setBidModalOpen: () => null,
  isSelling: false,
  tradeDetails: null
});

export default BidBoxContext;
